<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Configure Plant
          </h1>
        </div>
      </div>
    </div>
   <div class="mt-5">
    <form class="max-w-md">
      <div class="relative z-0 w-full mb-5 group">
          <input v-model="varietas" type="text" name="floating_email" id="floating_email" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
          <label for="floating_email" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Varietas</label>
      </div>
      <div class="relative z-0 w-full mb-5 group">
          <input v-model="taraf" type="number" name="floating_password" id="floating_password" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
          <label for="floating_password" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Taraf Cekaman</label>
      </div>
      <div class="relative z-0 w-full mb-5 group">
          <input v-model="ulangan" type="number" name="repeat_password" id="floating_repeat_password" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
          <label for="floating_repeat_password" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Ulangan</label>
      </div>
      <div>
        <div class="">
          <div class="inline-flex flex-col justify-center relative">
              <div class="relative">
                <input v-model="sensorIndex" type="text" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder="               search..." />
                <label for="floating_repeat_password" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Sensor</label>
              </div>
              <ul class="overflow-y-auto max-h-52 border-gray-100 w-full mt-2 ">
                  <li v-if="sensorChose != sensorIndex" v-on:click="sensorIndex=item.name,sensorChose=sensorIndex" v-for="(item, index) in dataSensor" :key="index" class="pl-3 py-1 border-b-2 dark:text-white border-gray-100 relative cursor-pointer hover:dark:bg-green-900 hover:bg-green-100 hover:text-gray-900">
                      {{ item.name }}
                  </li>
              </ul>
          </div>
        </div>
      </div>
      <button v-on:click.prevent="editPLant(dataDetailPlant.id,{varietas,taraf,ulangan,sensorIndex})" class="m-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
      <router-link :to="'/plant/'+ dataDetailPlant.id" class="m-3 ml-0 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Cancel</router-link>
    </form>
   </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { useCounterStore } from "@/store/counter";
  import { Icon } from "@iconify/vue";
  import { mapActions, mapState } from "pinia";
  export default {
    name: "Dashboard",
    data() {
      return {
        varietas: '' ,
        taraf:'',
        ulangan: '',
        sensorIndex: '',
        sensorChose: ''
      };
      // end chart data line
    },
    components: {
      Icon,
    },
    methods: {
      ...mapActions(useCounterStore,['getDetailPLant','editPLant','getDataSensor', 'delDataSensor']),
      async delButtonGroup(){
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        }).then((result) => {
          if (result.isConfirmed) {
          //  this.delGroup(this.dataGroupDetail.id)
          }
        });
      },
      fetchDataSensor() {
        this.getDataSensor(this.sensorIndex);
      }
    },
    created(){
      this.getDetailPLant(this.$route.params.id)
      this.delDataSensor()
    },
    computed: {
      ...mapState(useCounterStore, ['dataDetailPlant', 'dataSensor']),
      
    },
    watch: {
     dataDetailPlant : {
        handler() {
          this.varietas = this.dataDetailPlant.varietas
          this.taraf = this.dataDetailPlant.taraf
          this.ulangan = this.dataDetailPlant.ulangan
          this.sensorIndex = this.dataDetailPlant.sensorIndex
        },
        immediate: true
      },
      sensorIndex(newVal) {
        if (newVal) {
          if(this.sensorChose != this.sensorIndex){
            this.fetchDataSensor()
          }
        }
      }
    }
  };
</script>
